import { FC, ReactElement } from 'react';

import classNames from 'classnames';

import { ICardProps } from './card.interface';
import styles from './card.module.scss';

const Card: FC<ICardProps> = (props): ReactElement => {
  const {
    children,
    className,
    appearance = 'page',
    cardPadding = '1.5rem',
    maxWidth = 'auto',
    maxHeight = 'auto',
    paddingCardBottom = cardPadding,
    textAlign,
  } = props;

  const cardClassnames = classNames(styles.card, className, {
    [styles.surface]: appearance === 'surface',
    [styles.danger]: appearance === 'danger',
  });

  const cardStyles = {
    padding: cardPadding,
    paddingBottom: paddingCardBottom,
    maxWidth,
    maxHeight,
    textAlign,
  };
  return (
    <div style={cardStyles} className={cardClassnames}>
      {children}
    </div>
  );
};

export { Card };
